import { gql } from '@apollo/react-hooks'

export const ADD_PARTNER = gql`
  mutation Mutation($data: CreatePartnerInput!) {
    result: createPartner(data: $data) {
      id
    }
  }
`
